import { Button, MenuItem, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { addCourse } from "./redux/demoreducer";
import SectionCard from "./SectionCard";
import { connect } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { fetchRecipes, recipesSelector } from "./redux/recipes";

function DynamicFormAdding(props) {
  const [cardCount, setCardCount] = useState([]);
  var cardNumber = 0;

  const [type, setType] = useState("");
  const [course, setCourse] = useState({
    currentCourse: {
      courseName: "",
      courseDescription: "",
      isCertification: false,
      isFeedback: false,
      createdDateTime: 1234567890, // timestamp
      updatedDateTime: 1234567890, // timestamp
      isStudentAllowToJump: false,
      isFacultyEdit: false,
      draftOrPublish: "draft/published",
      sections: [
        {
          sectionTitle: "",
          sectionDescription: "",
          contentType: "video/document/assignment/quiz",
          contentTitle: "",
          credits: 10,
          contentDescription: "",
          resourceUploadLink:
            "videolink/documentlink/assignment document link/ quiz excel link",
          quizPassingGrade: 80,
          quizTime: 1000, //seconds
          sectionSubmitType: "pdf/word/image/audio/video/excel/any",
          videoTime: 4500, // seconds : calculate the time in frontend and send the seconds to server,
        },
      ],
    },
  });
  // initialize the redux hook
  const dispatch = useDispatch();
  const { recipes, loading, hasErrors } = useSelector(recipesSelector);

  // dispatch our thunk when component first mounts
  useEffect(() => {
    dispatch(fetchRecipes());
  }, [dispatch]);

  const handleChange = (e) => {
    setCourse({
      currentCourse: {
        ...course.currentCourse,
        [e.target.name]: e.target.value,
      },
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Course Object : ", course);
  };
  const handleCardClick = (e) => {
    e.preventDefault();
    // cardCount.push(cardNumber++);
    setCardCount((cardCount) => [
      ...cardCount,
      { cardCount: cardNumber++, cardType: type },
    ]);

    console.log(cardCount);
  };
  const add = (e) => {
    e.preventDefault();
    if (course.currentCourse.courseName === "") {
      alert("Input is Empty");
    } else {
      props.addCourse({
        type_: "course",
        title: course.currentCourse.courseName,
        description: course.currentCourse.courseDescription,
        completed: false,
      });
    }
  };
  const handlePostCourse = (e) => {
    e.preventDefault();
    console.log("data", props.section);
  };
  const handleChangeOption = (e) => {
    setType(e.target.value);
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Course Name"
          name="courseName"
          onChange={handleChange}
          value={course.currentCourse.courseName}
        />
        <input
          type="text"
          placeholder="Course Description"
          name="courseDescription"
          onChange={handleChange}
          value={course.currentCourse.courseDescription}
        />
        <Button type="submit" onClick={(e) => add(e)}>
          Submit
        </Button>

        {cardCount.length > 0 ? (
          <div>
            {" "}
            {cardCount.map((item, index) => {
              return (
                <div key={index}>
                  <SectionCard type={item.cardType} index_={index} />
                  {cardCount.length === index + 1 ? (
                    <div>
                      <Select
                        id="demo-simple-select"
                        value={type}
                        label="Age"
                        onChange={handleChangeOption}
                      >
                        <MenuItem value="video">Video</MenuItem>
                        <MenuItem value="assignment">Assignment</MenuItem>
                        <MenuItem value="quiz">Quiz</MenuItem>
                        <MenuItem value="document">Document</MenuItem>
                      </Select>
                      <Button onClick={handleCardClick}>Add Card</Button>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div>
            {" "}
            <div>
              <Select
                id="demo-simple-select"
                value={type}
                label="Age"
                onChange={handleChangeOption}
              >
                <MenuItem value="video">Video</MenuItem>
                <MenuItem value="assignment">Assignment</MenuItem>
                <MenuItem value="quiz">Quiz</MenuItem>
                <MenuItem value="document">Document</MenuItem>
              </Select>
              <Button onClick={handleCardClick}>Add Card</Button>
            </div>
          </div>
        )}
      </form>
      <Button onClick={handlePostCourse}>Post Course</Button>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    section: state,
   
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addCourse: (obj) => dispatch(addCourse(obj)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DynamicFormAdding);
// export default DynamicFormAdding ;
